import { graphql } from "../gql";

export const moveCasesToQueueMutationDoc = graphql(`
  mutation moveCasesToQueue($input: MoveCasesToQueueInput!) {
    moveCasesToQueue(input: $input) {
      ...CaseFragment
    }
  }
`);
